import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        " {\n    display: none;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cssVisuallyHidden, Envelope } from "@miro-site/core";
import styled from "styled-components";
import TopNavigation from "./TopNavigation";
var Label = styled.span.withConfig({
    componentId: "sc-67acef3b-0"
})(_templateObject());
var Icon = styled(Envelope).withConfig({
    componentId: "sc-67acef3b-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        width: theme.header.topNavigation.contactSales.icon.width,
        height: theme.header.topNavigation.contactSales.icon.height,
        color: "inherit"
    });
});
var Link = styled(TopNavigation.Link).withConfig({
    componentId: "sc-67acef3b-2"
})(_templateObject2(), Label, function(props) {
    return props.theme.mq.v2Desktop(cssVisuallyHidden);
}, Icon, function(props) {
    return props.theme.mq.v2Desktop({
        display: "block"
    });
});
var ContactSalesLink = function(props) {
    return /*#__PURE__*/ _jsxs(Link, {
        href: props.href,
        $appearance: props.appearance,
        children: [
            /*#__PURE__*/ _jsx(Label, {
                children: props.label
            }),
            /*#__PURE__*/ _jsx(Icon, {})
        ]
    });
};
export default Object.assign(ContactSalesLink, {
    Label: Label,
    Icon: Icon
});
